module.exports = {
  ENV: 'prod',
  APP_NAME: 'metropolis2',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'aHSsjUn8MwNSnY3CxwLc96qVdBs8AnL3fyxeHS72',
  BRAND_KEY: '65889770-7a69-4377-9dc7-5e50272d0c8d',
  CLIENT_ID: '2hcnhauq2qob6f67q6ikcb7of1',
  USER_POOL_ID: 'eu-west-1_HIn9p5IYR',
  HEADER_MESSAGE_SIZE: 41,
  AGENTS_GROUP: 'METROPOLIS2_AGENTS',
}